import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const DMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="DM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#279E19"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M8 0h1v7h7v1H9v4H8V8H0V7h8V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#272727"
          fillRule="evenodd"
          d="M7 0h1v6h8v1H8v5H7V7H0V6h7V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M6 0h1v5h9v1H7v6H6V6H0V5h6V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#C51918"
          fillRule="evenodd"
          d="M8 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
          clipRule="evenodd"
        />
        <Path
          fill="#804BFF"
          fillRule="evenodd"
          d="M7.363 4.207s.19-.617.631-.298c.692.34.92.732 1.188 1.175.267.444-.655.12-.827-.13-.172-.25-1.127-.331-.992-.54.135-.207 0-.207 0-.207Z"
          clipRule="evenodd"
        />
        <Path
          fill="#A95601"
          fillRule="evenodd"
          d="M7.207 7.363s-.47.643 0 .643 2.374-.139 2.146-.322c-.228-.183-1.92 0-1.92 0l-.226-.321Z"
          clipRule="evenodd"
        />
        <Path
          fill="#804BFF"
          fillRule="evenodd"
          d="M7.91 7.343c-.05-.055-.906-1.998-.508-2.402.398-.404.632-.166.632.44 0 .605.024 2.111-.125 1.962Z"
          clipRule="evenodd"
        />
        <Path
          fill="#279E19"
          fillRule="evenodd"
          d="M7.859 7.027s-.05.472.193 1.024c.243.55.733.54.733.089 0-.451.358-.028.496.273.137.301-.219-2.673-.724-3.339-.505-.666-.992-.708-.845-.278.147.43.147 2.231.147 2.231Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          fillRule="evenodd"
          d="M7.564 3.8s-.214.137-.214.514c0 .378.506-.116.506-.116L7.564 3.8Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FECA00"
          d="m8.27 8.647.493.071-.357.348.084.49-.44-.23-.44.23.084-.49-.357-.348.492-.071.221-.447.22.447Zm-1.859-.69.412.28-.473.156-.139.478-.295-.401-.498.015.291-.405-.168-.468.475.15.393-.304.002.498Zm4.128-.141.412.28-.473.156-.14.478-.294-.402-.498.016.291-.404-.168-.47.474.152.394-.304.002.498ZM5.37 5.846l.494.072-.357.348.084.491-.441-.232-.44.232.083-.491-.356-.348.493-.071.22-.447.22.447Zm5.7 0 .494.072-.358.348.085.491-.441-.232-.44.232.083-.491-.356-.348.492-.071.22-.447.222.447ZM6.296 3.915l.412.28-.473.157-.14.478-.294-.401-.498.015.291-.405-.168-.468.474.151.394-.305.002.498Zm4.175-.057.412.28-.473.156-.14.478-.294-.402-.498.015.29-.404L9.6 3.51l.475.152.393-.304.002.498Zm-2.2-1.11.493.072-.357.347.084.49-.44-.23-.44.23.084-.49-.357-.347.492-.073.221-.446.22.446Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
